import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { memo, useCallback } from "react";

import { Button } from "@/components/ui/button/button";
import Cross from "@/components/ui/icon/cross";

type Props = {
	title: string;
	thumbnail: string;
	widgetID: string;
	onRemoveSnack: () => void;
};

export const SnackCard = memo(({ title, thumbnail, widgetID, onRemoveSnack }: Props) => {
	const { attributes, listeners, setNodeRef, transform, transition, isSorting } = useSortable({
		id: widgetID,
	});

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	const handleClickRemoveSnack = useCallback(() => {
		onRemoveSnack();
	}, [onRemoveSnack]);

	return (
		<div className="relative w-full">
			<div className="w-full" ref={setNodeRef} style={style} {...attributes} {...listeners}>
				<img src={thumbnail} className="max-h-48 min-h-48 w-full rounded bg-cover bg-no-repeat object-cover" />

				<div className="absolute bottom-1 left-3 z-0">
					<p className="text-base text-white">{title}</p>
				</div>
			</div>

			{!isSorting && (
				<Button
					type="button"
					variant="no-outline"
					size="icon"
					className="absolute right-2 top-2"
					onClick={handleClickRemoveSnack}
				>
					<Cross />
				</Button>
			)}
		</div>
	);
});
